@let data = model();
@let columnData = column();

@switch (columnData.key) {
  @case (getColumnKey('progress')) {
    @if (data.isUndefinedProgress) {
      <app-progress-bar size="15px" />
    } @else {
      <app-progress-bar size="15px" mode="determinate" [value]="data.progress" />
    }
  }

  @case (getColumnKey('status')) {
    <app-admin-background-task-status [status]="data.status" />
  }

  @case (getColumnKey('type')) {
    <app-admin-background-task-type [type]="data.type" />
  }

  @default {
    <app-table-body-no-reference-cell [columnKey]="columnData.key" />
  }
}
